export enum eLocalStorageKeys {
  USER_JWT = 'USER_JWT',
  UI_LANGUAGE = 'UI_LANGUAGE',
  UI_THEME = 'UI_THEME'
}
